import classNames from "classnames";
import type { ReactNode } from "react";
import { LitRadio } from "./LitRadio";

interface RadioProps {
  label: ReactNode;
  supportingText?: string;
  onChange: (checked: boolean) => void;
  checked: boolean;
  disabled?: boolean;
  name: string;
  id?: string;
}

export default function Radio({ label, supportingText, onChange, checked, disabled = false, name, id }: RadioProps) {
  const radioId = id || name;

  return (
    <div className="flex items-start" data-testid="radio">
      <div className="flex-shrink-0 pt-0.5">
        <LitRadio
          disabled={disabled}
          checked={checked}
          name={name}
          id={radioId}
          onChange={(e) => onChange((e.target as HTMLInputElement).checked)}
        />
      </div>
      {supportingText ? (
        <div
          className={classNames("ml-3 cursor-pointer flex-1 flex flex-col gap-1", {
            "text-sys-brand-on-surface-variant opacity-[0.38]": disabled
          })}
          onClick={() => !disabled && onChange(!checked)}
        >
          <div className="text-body-large-semibold text-sys-brand-on-surface break-words">{label}</div>
          <div className="text-body-large text-sys-brand-on-surface-variant break-words">{supportingText}</div>
        </div>
      ) : (
        <label
          className={classNames("ml-3 text-body-large cursor-pointer flex-1", {
            "text-sys-brand-on-surface-variant opacity-[0.38]": disabled
          })}
          htmlFor={radioId}
        >
          {label}
        </label>
      )}
    </div>
  );
}
